import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAnalytics } from '../hooks/useAnalytics';

export const PageViewTracker = () => {
    const location = useLocation();
    const { analytics } = useAnalytics();

    useEffect(() => {
        analytics.trackPageView({
            documentTitle: document.title,
            href: window.location.href,
        });
    }, [location.pathname, location.search, location.hash]);

    return null;
};
